module.exports = __webpack_public_path__ + "img/logo-filmmx.2e244a58.svg";